import React, { useState } from "react";
import moment from "moment";

const ItemDetailsModal = ({ showModal, setShowModal, handleAddItem }) => {
    const [itemDetails, setItemDetails] = useState({
        isMainItem: true,
        itemType: "",
        itemSerialNo: "",
        itemDescription: "",
        purchaseDateMfg: "",
        warrantyMonthsMfg: "",
        warrantyDateMfg: "",
        installationDate: "",
        warrantyMonthsCust: "",
        warrantyDateCust: "",
    });

    const itemTypes = ["Electronics", "Appliances", "Furniture", "Others"];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setItemDetails((prev) => ({ ...prev, [name]: value }));
    };

    const handleDateChange = (name, date) => {
        setItemDetails((prev) => ({
            ...prev,
            [name]: moment(date).format("YYYY-MM-DD"),
        }));
    };

    const handleSubmit = () => {
        handleAddItem(itemDetails);
        setShowModal(false);
    };

    return (
        <>
            {showModal && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content shadow-lg rounded">
                            <div className="modal-header bg-primary text-white">
                                <h5 className="modal-title">Item Details</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    {/* Is Main Item */}
                                    <div className="mb-4">
                                        <label className="form-label d-flex">Is Main Item?</label>
                                        <div className="d-flex">
                                            <div className="form-check me-4">
                                                <input
                                                    type="radio"
                                                    id="isMainItemYes"
                                                    name="isMainItem"
                                                    value={true}
                                                    checked={itemDetails.isMainItem === true}
                                                    onChange={handleChange}
                                                    className="form-check-input"
                                                />
                                                <label htmlFor="isMainItemYes" className="form-check-label">
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    id="isMainItemNo"
                                                    name="isMainItem"
                                                    value={false}
                                                    checked={itemDetails.isMainItem === false}
                                                    onChange={handleChange}
                                                    className="form-check-input"
                                                />
                                                <label htmlFor="isMainItemNo" className="form-check-label">
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Item Type */}
                                    <div className="mb-4">
                                        <label className="form-label d-flex">Item Type</label>
                                        <select
                                            name="itemType"
                                            className="form-select"
                                            value={itemDetails.itemType}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Item Type</option>
                                            {itemTypes.map((type, index) => (
                                                <option key={index} value={type}>
                                                    {type}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Item Serial No */}
                                    <div className="mb-4">
                                        <label className="form-label d-flex">Item Serial No#</label>
                                        <input
                                            type="text"
                                            name="itemSerialNo"
                                            className="form-control"
                                            value={itemDetails.itemSerialNo}
                                            onChange={handleChange}
                                            placeholder="Enter item serial number"
                                        />
                                    </div>

                                    {/* Item Description */}
                                    <div className="mb-4">
                                        <label className="form-label d-flex">Item Description</label>
                                        <textarea
                                            name="itemDescription"
                                            className="form-control"
                                            value={itemDetails.itemDescription}
                                            onChange={handleChange}
                                            placeholder="Provide a brief description"
                                        />
                                    </div>

                                    <div className="row mb-4">
                                        <div className="col-4">
                                            <label className="form-label d-flex">Purchase Date (mfg)</label>
                                            <input
                                                type="date"
                                                name="purchaseDateMfg"
                                                className="form-control"
                                                value={itemDetails.purchaseDateMfg}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-4">
                                            <label className="form-label d-flex">Warranty Months (mfg)</label>
                                            <input
                                                type="number"
                                                name="warrantyMonthsMfg"
                                                className="form-control"
                                                value={itemDetails.warrantyMonthsMfg}
                                                onChange={handleChange}
                                                placeholder="Enter warranty months"
                                            />
                                        </div>
                                        <div className="col-4">
                                            <label className="form-label d-flex">Warranty Date (mfg)</label>
                                            <input
                                                type="date"
                                                name="warrantyDateMfg"
                                                className="form-control"
                                                value={itemDetails.warrantyDateMfg}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-4">
                                        <div className="col-4">
                                            <label className="form-label d-flex">Installation Date</label>
                                            <input
                                                type="date"
                                                name="installationDate"
                                                className="form-control"
                                                value={itemDetails.installationDate}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-4">
                                            <label className="form-label d-flex">Warranty Months (Customer)</label>
                                            <input
                                                type="number"
                                                name="warrantyMonthsCust"
                                                className="form-control"
                                                value={itemDetails.warrantyMonthsCust}
                                                onChange={handleChange}
                                                placeholder="Enter customer warranty months"
                                            />
                                        </div>
                                        <div className="col-4">
                                            <label className="form-label d-flex">Warranty Date (Customer)</label>
                                            <input
                                                type="date"
                                                name="warrantyDateCust"
                                                className="form-control"
                                                value={itemDetails.warrantyDateCust}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSubmit}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ItemDetailsModal;
